module.exports = __webpack_public_path__ + "static/media/red_number_of_sessions.e409ead8.svg";